import React from "react";
import "./Home.css";

function Home() {
  return (
    <div className="home">
      <div className="home-container">
        {/* Partie gauche - Description */}
        <div className="home-description">
          <h1>Bienvenue sur mon portfolio</h1>
          <p>
            Je suis{" "}
            <strong>
              Joseph KOUAKOU
            </strong>
            , développeur full stack passionné. J'ai une expérience approfondie
            dans la création d'applications web performantes, modernes et
            évolutives. Découvrez mes compétences et mes projets à travers ce
            site.
          </p>
          <button className="cta-button">
            <a href="/skills">En savoir plus</a>
          </button>

          {/* Boutons supplémentaires */}
          <div className="home-buttons">
            <a href="/cv.pdf" download className="cta-button cv-button">
              Télécharger mon CV
            </a>
            <a href="/contact" className="cta-button">
              M'écrire
            </a>
          </div>
        </div>

        {/* Partie droite - Photo */}
        <div className="home-photo">
          <img
            src="/images/jo.jpg"
            alt="tof de profil"
            className="profile-photo"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
